import { render, staticRenderFns } from "./FileAlert.vue?vue&type=template&id=34f02032&scoped=true&"
import script from "./FileAlert.vue?vue&type=script&lang=js&"
export * from "./FileAlert.vue?vue&type=script&lang=js&"
import style0 from "./FileAlert.vue?vue&type=style&index=0&id=34f02032&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f02032",
  null
  
)

export default component.exports